
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.61 9.84998L18.17 10.41L9.69 18.9C9.3 19.29 9.3 19.92 9.69 20.31C10.08 20.7 10.71 20.7 11.1 20.31L19.59 11.82L20.15 12.38C20.46 12.7 21 12.48 21 12.04V9.49998C21 9.21998 20.78 8.99998 20.5 8.99998H17.96C17.52 8.99998 17.3 9.53998 17.61 9.84998ZM8.48 12.75L12.02 9.20998L13.62 9.87998C13.98 10.03 14.39 9.94998 14.67 9.66998C15.16 9.17998 14.99 8.35998 14.35 8.09998L5.26 4.49998C4.83 4.33998 4.35 4.43998 4.03 4.75998C3.71 5.07998 3.61 5.55998 3.78 5.98998L7.39 15.08C7.64 15.72 8.47 15.89 8.96 15.4C9.24 15.12 9.32 14.71 9.17 14.35L8.48 12.75ZM7.66 11.03L5.43 6.15998L10.3 8.38998L7.66 11.03Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-text-rotation-angleup`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTextRotationAngleup

    ```js
    <b-new-b-icon-text-rotation-angleup />
    ```
</docs>


